var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.type === "name"
      ? _c("div", [
          _vm.boldHeader
            ? _c("div", { staticClass: "body__normal-medium" }, [
                _vm._v("\n      " + _vm._s(_vm.boldHeader) + "\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.personName
            ? _c(
                "div",
                {
                  staticClass:
                    "body__small-regular__secondary personName__container body",
                },
                [
                  _c("img", {
                    staticClass: "personName__icon",
                    attrs: { src: _vm.personIcon },
                  }),
                  _vm._v("\n      " + _vm._s(_vm.personName) + "\n    "),
                ]
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "frequency"
      ? _c("div", [
          _vm.frequencyRange
            ? _c("div", { staticClass: "body__normal-regular" }, [
                _vm._v("\n      " + _vm._s(_vm.frequencyRange) + "\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.allowedDays
            ? _c(
                "div",
                { staticClass: "body__small-regular__secondary body" },
                [_vm._v("\n      " + _vm._s(_vm.allowedDays) + "\n    ")]
              )
            : _vm._e(),
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.type === "accessPeriod"
      ? _c("div", [
          _vm.accessPeriodRange
            ? _c("div", { staticClass: "body__normal-regular" }, [
                _vm._v("\n      " + _vm._s(_vm.accessPeriodRange) + "\n    "),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.expiredOn
            ? _c(
                "div",
                { staticClass: "body__small-medium__secondary body red" },
                [
                  _c(
                    "span",
                    { staticClass: "body__small-medium__secondary red" },
                    [_vm._v("Expired on: ")]
                  ),
                  _vm._v(_vm._s(_vm.expiredOn) + "\n    "),
                ]
              )
            : _vm.deletedOn
            ? _c(
                "div",
                { staticClass: "body__small-medium__secondary body red" },
                [
                  _c(
                    "span",
                    { staticClass: "body__small-medium__secondary red" },
                    [_vm._v("Deleted on: ")]
                  ),
                  _vm._v(_vm._s(_vm.deletedOn) + "\n    "),
                ]
              )
            : _vm.createdOn
            ? _c("div", { staticClass: "body__small-medium__secondary body" }, [
                _c("span", { staticClass: "body__small-medium__secondary" }, [
                  _vm._v("Created on: "),
                ]),
                _vm._v(_vm._s(_vm.createdOn) + "\n    "),
              ])
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }